import api from '@/lib/api';
import type { PosPaidOut } from '@pms/shared';

// ─── Query / payload types ────────────────────────────────────────────────────

export interface ListPaidOutsQuery {
  propertyId: string;
}

export interface CreatePaidOutPayload {
  propertyId: string;
  /** Positive disbursement amount. */
  amount: number;
  reason: string;
  recipient: string;
  /** ISO date (yyyy-MM-dd). Posts as `date`. */
  date: string;
  note?: string | undefined;
}

/** A paid-out row, optionally carrying a resolved actor name for the table. */
export type PaidOutRow = PosPaidOut & { createdByName?: string | null };

// ─── API functions ────────────────────────────────────────────────────────────

export async function fetchPaidOuts(query: ListPaidOutsQuery): Promise<PaidOutRow[]> {
  const { data } = await api.get<PaidOutRow[]>('/retail/paid-outs', { params: query });
  return data;
}

export async function createPaidOut(payload: CreatePaidOutPayload): Promise<PaidOutRow> {
  const { data } = await api.post<PaidOutRow>('/retail/paid-outs', payload);
  return data;
}
